export default "__VITE_ASSET__67W_oTHs__"